/* global Swiper */

// *******************************************************************************
// 1.0 - Gallery Modal Slider
// *******************************************************************************

const galleryModalSliderElements = document.querySelectorAll('[data-slider="gallery-modal-slider"]');

const galleryModalSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 800,
  loopAdditionalSlides: 30,
  loop: true,
  watchOverflow: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
};

galleryModalSliderElements.forEach((el, i) => {
  const galleryModalSliderParent = el.closest('.gallery-modal');
  const arrowRight = galleryModalSliderParent.querySelector('.arrow-right');
  const arrowLeft = galleryModalSliderParent.querySelector('.arrow-left');

  galleryModalSliderOptions.navigation.nextEl = arrowRight;
  galleryModalSliderOptions.navigation.prevEl = arrowLeft;

  // eslint-disable-next-line no-new
  const galleryModalSlider = new Swiper(el, galleryModalSliderOptions);

  attachEvent('[data-modal-slide]', 'click', (ev) => {
    const targetSlideEle = ev.target.closest('.gallery__slide');
    const targetSlideAttr = targetSlideEle.getAttribute('data-modal-slide');
    galleryModalSlider.slideTo(targetSlideAttr - 1, 0);
  });
});

// **********************************************************
// 3.0 - Gallery Modal Close
// **********************************************************

attachEvent('.gallery-modal__close', 'click', (ev) => {
  ev.target.closest('.gallery-modal').classList.remove('is-open-modal');
});

// **********************************************************
// 4.0 - Closing Modal on Esc
// **********************************************************

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    const mapModal = document.querySelectorAll('.map-modal');
    const galleryModal = document.querySelectorAll('.gallery-modal');

    if (galleryModal.length > 0) {
      galleryModal.forEach((el) => {
        el.classList.remove('is-open-modal');
      });
    }

    if (mapModal.length > 0) {
      mapModal.forEach((el) => {
        el.classList.remove('is-open-modal');
      });
    }
  }
});
